import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

export const ShareModal = ({
  open, onOpenChange, shareLevel, setShareLevel, shareInfo,
  sharingCollectionId, currentPlan, collabEmail, setCollabEmail,
  collaborators, onShareCollection, onUnshareCollection,
  onCopyShareLink, onAddCollaborator, onRemoveCollaborator,
}) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="modal-dark sm:max-w-md">
      <DialogHeader>
        <DialogTitle className="font-serif text-[#FDF8EE]">Share Volume</DialogTitle>
      </DialogHeader>
      <div className="py-4 space-y-5">
        {/* Share Level */}
        <div>
          <label className="label-dark">Share Level</label>
          <div className="space-y-2 mt-2">
            {[
              { value: "shared_link", label: "Shared — Link", desc: "Anyone with the link can view (read-only)", icon: "◈" },
              { value: "shared_collaborators", label: "Shared — Collaborators", desc: "Named collaborators can add entries", icon: "◎", synthOnly: true },
            ].map(opt => (
              <button
                key={opt.value}
                onClick={() => { setShareLevel(opt.value); onShareCollection(sharingCollectionId, opt.value); }}
                className={`w-full text-left p-3 border transition-colors ${shareLevel === opt.value ? 'border-[#E8A030] bg-[rgba(232,160,48,0.06)]' : 'border-[rgba(232,160,48,0.1)] hover:border-[rgba(232,160,48,0.2)]'} ${opt.synthOnly && !currentPlan?.includes('synthesis') && !currentPlan?.includes('enterprise') ? 'opacity-50' : ''}`}
                data-testid={`share-level-${opt.value}`}
              >
                <div className="flex items-center gap-2 mb-0.5">
                  <span className="text-[#E8A030] text-xs">{opt.icon}</span>
                  <span className="text-sm text-[#FDF8EE] font-medium">{opt.label}</span>
                  {opt.synthOnly && <span className="font-mono text-[7px] text-[#A08CC8] bg-[rgba(160,140,200,0.12)] px-1.5 py-0.5 uppercase tracking-[1px]">Synthesis</span>}
                </div>
                <p className="text-[11px] text-[#4A3A1A] ml-5">{opt.desc}</p>
              </button>
            ))}
          </div>
        </div>

        {/* Share Link */}
        {shareInfo && (
          <div className="space-y-3">
            <label className="label-dark">Share Link</label>
            <div className="flex gap-2">
              <input readOnly value={`${window.location.origin}${shareInfo.share_url}`} className="input-dark flex-1 text-xs" data-testid="share-link-input" />
              <button onClick={onCopyShareLink} className="btn-primary px-3" data-testid="copy-share-link-btn">Copy</button>
            </div>
            <button onClick={() => onUnshareCollection(sharingCollectionId)} className="w-full text-center font-mono text-[9px] text-red-400 hover:underline uppercase tracking-[1px] py-2" data-testid="revoke-share-btn">Make Private (Revoke Link)</button>
          </div>
        )}

        {/* Collaborator Management */}
        {shareLevel === "shared_collaborators" && shareInfo && (
          <div className="space-y-3 border-t border-[rgba(232,160,48,0.1)] pt-4">
            <label className="label-dark">Collaborators</label>
            <div className="flex gap-2">
              <input value={collabEmail} onChange={e => setCollabEmail(e.target.value)} placeholder="collaborator@email.com" className="input-dark flex-1 text-xs" onKeyDown={e => e.key === 'Enter' && onAddCollaborator()} data-testid="collab-email-input" />
              <button onClick={onAddCollaborator} className="btn-primary px-3 text-xs" data-testid="add-collab-btn">Add</button>
            </div>
            {collaborators.length > 0 && (
              <div className="space-y-1.5">
                {collaborators.map((c, i) => (
                  <div key={i} className="flex items-center justify-between bg-[rgba(160,140,200,0.05)] border border-[rgba(160,140,200,0.1)] px-3 py-2">
                    <div>
                      <span className="text-xs text-[#F5ECD0]">{c.name || c.email}</span>
                      {c.name && <span className="font-mono text-[8px] text-[#4A3A1A] ml-2">{c.email}</span>}
                    </div>
                    <button onClick={() => onRemoveCollaborator(c.email)} className="text-[#4A3A1A] hover:text-red-400 text-xs transition-colors" data-testid={`remove-collab-${i}`}>&times;</button>
                  </div>
                ))}
              </div>
            )}
            {collaborators.length === 0 && <p className="text-[10px] text-[#4A3A1A] italic">No collaborators yet. Add team members by email.</p>}
          </div>
        )}
      </div>
    </DialogContent>
  </Dialog>
);
